import { useState, useEffect } from "react";
import { useSession } from "next-auth/react";
import { verifyUserCountry } from "controllers/miscellaneous";
import { useFirebaseUser } from "./useFirebaseUser";

export function useLocation() {
  const [isFromIndia, setIsFromIndia] = useState<boolean>(false);
  const [hasFetched, setHasFetched] = useState<boolean>(false);
  const isAuthenticated = useFirebaseUser();
  const { data: session } = useSession() ?? {}
  useEffect(() => {
    const verify = async () => {
      const fromIndia = await verifyUserCountry("IN");
      if (fromIndia) {
        setIsFromIndia(true);
      }
    };
    if (isAuthenticated && !hasFetched) {
      setHasFetched(true);
      verify();
    }
  }, [session, isAuthenticated]);

  return { isFromIndia };
}
